module.exports = __webpack_public_path__ + "img/vrspace-rao.618632d3.jpg";